module.exports = __webpack_public_path__ + "static/media/query_grey.42bc40f6.svg";